(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-switcher"] && !Shopify.designMode) return;
  try {
    class LocalizationSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-localization-toggle]');
      this.panel = this.querySelector('[data-localization-panel]');

      this.toggle.addEventListener('click', () => {
        const isOpen = !this.panel.hidden;
        this.panel.hidden = isOpen;
        this.toggle.setAttribute('aria-expanded', String(!isOpen));
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.panel.hidden = true;
      });

      this.querySelectorAll('[data-locale-option]').forEach((button) => {
        button.addEventListener('click', () => {
          const form = this.querySelector('[data-locale-input]').closest('form');
          this.querySelector('[data-locale-input]').value = button.dataset.localeCode;
          form.submit();
        });
      });

      this.querySelectorAll('[data-country-option]').forEach((button) => {
        button.addEventListener('click', () => {
          const form = this.querySelector('[data-country-input]').closest('form');
          this.querySelector('[data-country-input]').value = button.dataset.countryCode;
          form.submit();
        });
      });
    }
  }

  if (!customElements.get('localization-switcher')) {
    customElements.define('localization-switcher', LocalizationSwitcher);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductOptionCard extends HTMLElement {
    connectedCallback() {
      this.ctaElement = this.querySelector('[data-cta]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.options = this.querySelectorAll('.product-card__option');

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.select(option));
      });
    }

    select(selectedOption) {
      this.options.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected);
      });

      this.variantInput.value = selectedOption.dataset.variantId;
      this.ctaElement.textContent = selectedOption.dataset.ctaLabel;
    }
  }

  customElements.define('product-option-card', ProductOptionCard);
  } catch(e) { console.error(e); }
})();

})();
